import Request from "./request";
const Statistics = "/statistics/users";
const StatisticProject = "/statistics/projects";

export default {
  async getStatistics() {
    return Request.get(Statistics);
  },
  async getStatisticProjects() {
    return Request.get(StatisticProject);
  }
};
